export default "__VITE_ASSET__rPZsai3S__"